export default __webpack_public_path__ + "static/media/6545840f7452bcae87a41bd0fe801a24.jpg";